<script lang="ts" setup>
/**
 * Shared "Help and Support" section for the side menu, used on both the
 * portal site (SideMenu.vue / .hmbSidebar) and the compliance/framework
 * site (SideMenu.vue / .sidebar).
 *
 * The two menus lay out sections differently:
 * - Compliance nests each group in a `.section` div so `.section > a` picks
 *   up the link styling (`wrapInSection: true`, the default).
 * - Portal styles links directly via `.hmbSidebar > a`, with `.header`/
 *   `.routes` as flat siblings rather than nested in a wrapper
 *   (`wrapInSection: false`).
 * Pass `wrapInSection` accordingly so the section visually matches its
 * neighbours on whichever menu it's dropped into.
 */
withDefaults(
  defineProps<{
    supportTicketsPath?: string;
    helpFaqPath?: string;
    isCurrentRoute?: (path: string) => boolean;
    wrapInSection?: boolean;
  }>(),
  {
    supportTicketsPath: "/support-tickets",
    helpFaqPath: "/help-faq",
    isCurrentRoute: () => false,
    wrapInSection: true,
  },
);
</script>

<template>
  <div v-if="wrapInSection" class="section setup-start">
    <div class="header">Help and Support</div>
    <router-link :to="supportTicketsPath" class="routes">
      Support Tickets
    </router-link>
    <router-link :to="helpFaqPath" class="routes"> Help / FAQ </router-link>
  </div>
  <template v-else>
    <div class="header">Help and Support</div>
    <router-link :to="supportTicketsPath" class="routes">
      Support Tickets
    </router-link>
    <router-link :to="helpFaqPath" class="routes"> Help / FAQ </router-link>
  </template>
</template>
